import React from 'react';

const BlogSkeleton = () => {
    return (
        <div className='flex flex-wrap justify-center lg:justify-evenly gap-10 py-12 px-4'>
            <div className="card w-[22.5rem] bg-base-100 shadow-xl overflow-hidden">
                <div className="skeleton h-52 w-full rounded-none"></div>
                <div className='card-body'>
                    <div className="skeleton h-4 w-28"></div>
                    <div className="skeleton h-4 w-full"></div>
                    <div className="skeleton h-4 w-full"></div>
                    <div className="card-actions justify-end mt-8">
                        <div className='skeleton h-10 w-28 rounded-full'></div>
                    </div>
                </div>
            </div>

            <div className="card w-[22.5rem] bg-base-100 shadow-xl overflow-hidden">
                <div className="skeleton h-52 w-full rounded-none"></div>
                <div className='card-body'>
                    <div className="skeleton h-4 w-28"></div>
                    <div className="skeleton h-4 w-full"></div>
                    <div className="skeleton h-4 w-full"></div>
                    <div className="card-actions justify-end mt-8">
                        <div className='skeleton h-10 w-28 rounded-full'></div>
                    </div>
                </div>
            </div>

            <div className="card w-[22.5rem] bg-base-100 shadow-xl overflow-hidden">
                <div className="skeleton h-52 w-full rounded-none"></div>
                <div className='card-body'>
                    <div className="skeleton h-4 w-28"></div>
                    <div className="skeleton h-4 w-full"></div>
                    <div className="skeleton h-4 w-full"></div>
                    <div className="card-actions justify-end mt-8">
                        <div className='skeleton h-10 w-28 rounded-full'></div>
                    </div>
                </div>
            </div>

            <div className="card w-[22.5rem] bg-base-100 shadow-xl overflow-hidden">
                <div className="skeleton h-52 w-full rounded-none"></div>
                <div className='card-body'>
                    <div className="skeleton h-4 w-28"></div>
                    <div className="skeleton h-4 w-full"></div>
                    <div className="skeleton h-4 w-full"></div>
                    <div className="card-actions justify-end mt-8">
                        <div className='skeleton h-10 w-28 rounded-full'></div>
                    </div>
                </div>
            </div>

            <div className="card w-[22.5rem] bg-base-100 shadow-xl overflow-hidden">
                <div className="skeleton h-52 w-full rounded-none"></div>
                <div className='card-body'>
                    <div className="skeleton h-4 w-28"></div>
                    <div className="skeleton h-4 w-full"></div>
                    <div className="skeleton h-4 w-full"></div>
                    <div className="card-actions justify-end mt-8">
                        <div className='skeleton h-10 w-28 rounded-full'></div>
                    </div>
                </div>
            </div>

            <div className="card w-[22.5rem] bg-base-100 shadow-xl overflow-hidden">
                <div className="skeleton h-52 w-full rounded-none"></div>
                <div className='card-body'>
                    <div className="skeleton h-4 w-28"></div>
                    <div className="skeleton h-4 w-full"></div>
                    <div className="skeleton h-4 w-full"></div>
                    <div className="card-actions justify-end mt-8">
                        <div className='skeleton h-10 w-28 rounded-full'></div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default BlogSkeleton;
